export default __webpack_public_path__ + "static/media/carges-card.d22febe9.png";